import { IonCol, IonContent, IonGrid, IonIcon, IonItem, IonRow, IonText } from "@ionic/react"
import { clipboardOutline, location, calendar, map, radioButtonOff } from 'ionicons/icons';
import { timeAgo, toAppDateFormat, toAppFormat, toAppTimeFormat } from "../services/time";
import { truncate } from "../services/util";
import styled from 'styled-components';
import StarRatingComponent from 'react-star-rating-component';
import {star, walk, starHalf } from 'ionicons/icons';
 
interface TeamCardProps {
  team: any
}
 
const TeamCard: React.FC<TeamCardProps> = ({ team }) => {
 
  return (
    <IonItem routerLink={`/team/edit/${team.id}`} detail={true}>
      <IonGrid>
        <IonRow style={{ overflow: 'hidden',borderRadius: '10px',width:'100%', paddingLeft:'40px'}}>
          <IonCol size-md="16" style={{ background: '',padding: "0px 0px 0 8px",width:'100%'}}>
            <IonRow>
                 <IonCol size="6" style={{ fontSize: '16px',padding: "0px 0px 0px 5px", width: '0%' }}>
                {/* <StarRatingComponent
                  value={team.rating}
                  name="user-rating"
                  editing={false}
                  starColor={'var(--ion-color-text)'}
                  emptyStarColor="#777"
                  renderStarIcon={() => <IonIcon style={{ background: '#fff' }} icon={star} />}
                  renderStarIconHalf={() => <IonIcon icon={starHalf} />}
                /> */}

                <IonText style={{background:"transparent", color:"#000", padding:"4px 0px", borderRadius:"5px"}}>
                          {team?.rating.toFixed(1)} <IonIcon icon={star} style={{color:"#000", marginLeft: "5px", width: "15px"}} />
                </IonText>


              </IonCol>
            </IonRow>
 
            <IonRow>
                <IonCol size="6">
                <IonText
                  style={{
                    width: '100%',
                    fontSize: '18px',
                    padding: '0px 0px 0 5px',
                  }}
                >
                {team.name}
                </IonText>
 
              <IonRow className="ion-align-items-center">
                <IonCol style={{ maxWidth: '22px' }}>
                  <IonIcon style={{ marginRight: "5px", fontSize: '18px',marginTop:'5px' }} color="main-text" icon={location} />
                </IonCol>
                <IonCol>
                  <IonRow>
                    <IonText style={{ fontSize: '15px', marginTop:'5px', }}>{team?.location}</IonText>
                  </IonRow>
                </IonCol>
              </IonRow>
            </IonCol>
 
              <IonCol size="6">
                <IonText
                  style={{
                    width: '100%',
                    fontSize: '18px',
                    padding: '0px 0px 0 5px',
                  }}
                >
               {team.sport.name}
                </IonText>
 
              <IonRow className="ion-align-items-center">
                <IonCol>
                  <IonRow style={{marginTop:'3px'}}>
                    <IonText style={{ fontSize: '16px', marginLeft:'5px' }}>{team?.rank}</IonText>
                  </IonRow>
                </IonCol>
              </IonRow>
            </IonCol>
            </IonRow>
          </IonCol>
        </IonRow>
      </IonGrid>
 
    </IonItem>
  )
}
 
export default TeamCard;